<template>
  <div class="p_supply_module p_supplys_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">施工队名称</div>
                    <el-input v-model="listQuery.strConstrteamName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <!-- <div class="screenInput">
                  <div class="flname">岗位</div>
                  <el-input v-model="listQuery.strMobile" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box" v-loading="tableLoading">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane v-if="checkPermission(['supplierManage_tab_list'],permissionLists)" label="施工队列表" name="first">
              <div class="r_act_box">
                <div class="r_act_left">
                  <div class="r_act_item" v-if="checkPermission(['supplierManage_add'],permissionLists)">
                    <el-button size="small" type="success" @click="addSupHandle">新增施工队</el-button>
                  </div>
                  <div class="r_act_item" v-if="!this.isNull(this.tableData)&&checkPermission(['supplierManage_export'],permissionLists)">
                    <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
                  </div>
                </div>
              </div>
              <el-table ref="clueTable" class="re_table" border :header-cell-style="{background:'#f2f2f2',color: '#909399'}" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
                  <!-- <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
                    <template slot-scope="{$index}">
                        <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
                      </template>
                  </el-table-column> -->
                  <template v-for="(item,index) in tableTitle">
                    <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('代码')>-1||item.StrColumName.indexOf('套餐')>-1||item.StrColumName.indexOf('负责人身份证')>-1 ? '160px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('电子邮箱')>-1||item.StrColumName.indexOf('时间')>-1?'150px':'110px'" align="center"
                      :fixed="item.StrColumName=='施工队名称'||item.StrColumName=='施工队编号'">
                      <template slot-scope="{row}">
                        <p v-if="item.StrColumId=='StrConstrteamName'" class="auth_box">
                          <img src="./../../assets/images/auth.png" alt="" v-if="row.StrExamStatus=='已认证'">
                          <!-- <img src="./../../assets/images/auth_fail.png" alt="" v-else-if="row.StrExamStatus=='认证失败'">
                          <img src="./../../assets/images/unauth.png" alt="" v-else> -->
                          <span class="auth_title">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                        </p>
                        <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                      </template>
                    </el-table-column>
                  </template>
                  <el-table-column align="center" label="操作" fixed="right" width="320px" class-name="re_act_box">
                    <template slot-scope="{row}">
                      <el-button type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
                      <el-button v-if="checkPermission(['supplierManage_edit'],permissionLists)" type="info" size="mini" plain @click="editHandle(row)">编辑</el-button>
                      <el-button v-if="checkPermission(['supplierManage_messenger'],permissionLists)" type="info" size="mini" plain @click="editInfoHandle(row)">更改信息员</el-button>
                      <el-button v-if="row.StrSerStatus!='退出'&&(checkPermission(['supplierManage_exit'],permissionLists))" type="info" size="mini" plain @click="exitHandle(row)">退出</el-button>
                    </template>
                  </el-table-column>
              </el-table>
              <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page.sync="listQuery.currpage"
                  :page-size="listQuery.perpage"
                  @size-change="handleSizeChange"
                  :page-sizes="[10, 20, 50, 100, 200]"
                  layout="total,sizes,prev,pager,next,jumper"
                  :total="total"
                ></el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="checkPermission(['supplierManage_tab_remind'],permissionLists)" label="施工队提醒" name="second"></el-tab-pane>
            <el-tab-pane v-if="checkPermission(['supplierManage_tab_recertification'],permissionLists)" label="施工队重新认证列表" name="third"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
    <!-- 修改退出时间弹框 -->
    <el-dialog title="设置退出时间" :visible.sync="exitVisible" width="700px" class="res_dialog">
      <el-form :model="exitQuery" :rules="exitRules" ref="exitForm" class="re_dialog_form" label-width="130px">
        <el-form-item label="退出时间:" prop="DtexitDate">
            <el-date-picker size="small" value-format="yyyy-MM-dd" format='yyyy-MM-dd'
                  v-model="exitQuery.DtexitDate"
                  type="date"
                  placeholder="">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="strRemark">
            <el-input v-model="exitQuery.strRemark" type="textarea" size="small" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="exitVisible = false"
            size="small"
            >取消</el-button>
          <el-button
            type="primary" class="com_dialog_btn"
            @click="saveExitHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
    <!-- 修改信息员弹框 -->
    <el-dialog title="更改信息员" :visible.sync="cusVisible" width="600px" class="cus_dialog">
      <el-form :model="infoQuery" label-width="100px" class="demo-ruleForm">
        <el-form-item label="信息员:" prop="strservuserid">
          <el-select
                  v-model="infoQuery.StrTeamUserid" filterable clearable style="width:300px;margin-right:8px;"
                >
                  <el-option
                    v-for="(item, index) in custList"
                    :key="index+'t'"
                    :label="item.Username"
                    :value="item.Userid">
                  </el-option>
                </el-select>
                <el-button @click="unbindHandle" type="success" plain>解绑人员</el-button>
        </el-form-item>
        <!-- <el-form-item label="" v-if="selServiceList.length>0">
          <div class="error_txt">
            <div v-for="(item, index) in selServiceList" :key="index+'s'" class="error_item">
              <p>温馨提示:{{item}}客服非您负责区域的客服人员,请确认！</p>
              <i class="el-icon-close" @click="dltErrorHandle(index)"></i>
            </div>
          </div>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="cusVisible = false"
            size="small"
            >取消</el-button
          >
          <!-- <el-popconfirm confirm-button-text='确定' icon="el-icon-info" icon-color="red" v-if="isNull(infoQuery.StrTeamUserid)" @confirm="saveCusHandle" title="请确认是否解绑客服？">
            <el-button slot="reference" class="pinkButton" type="primary" size="small" style="margin-left: 10px;">保存</el-button>
          </el-popconfirm> -->
          <el-button
            type="primary"
            @click="saveCusHandle"
            size="small"
            >保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        cusVisible:false,
        downVisible:false,
        custPath: '',//导出文件下载路径
        tablePath: this.$store.state.EMP.tablePath,
        infoQuery:{
          GdteamId:'',
          StrTeamUserid:''//选择人员
        },
        editCusVal:[],
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'施工队列表',
        activeName:'',
        tableData: [],
        // 退出规则
        exitRules: {
            DtexitDate: [
                { required: true, message: '请选择退出时间', trigger: 'change' }
            ]
        },
        listQuery:{
          strConstrteamName:'',// 施工队名称
          strSerStatus:'',// 服务状态 正常/退出
          strExamStatus:'',// 通过/不通过
          strArea:'',//区域
          strCityCompany:'',//城市公司
          currpage:1,
          perpage:10
        },
        // 表头参数
        titleQuery:{
          strTableId:'JB_busi_ConstrTeam', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
          strIsFixed:''
        },
        exportQuery:{},
        btnLoading:false,
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        exitVisible:false,
        // 退出参数
        exitQuery:{
          GdupId:'',//标识
          DtexitDate:'',//退出时间
          strTableId:'JB_busi_ConstrTeam',//JB_busi_ConstrTeam 施工队 JB_busi_ConstrPerson施工队员
          strRemark:'' //备注
        },
        // 人员列表
        custList:[],
        oneQuery:{
          username:'',
          currpage:1,
          perpage:1000000
        },
        // 按钮权限参数
        butQuery:{
          path:'/supplierManage',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
      this.calHeight();
      this.getButtonPower()
      if(!this.isNull(this.$route.query.active)){
        this.activeName = this.$route.query.active
        // 表头
        this.getTableTitleLists()
        this.getOneLists()
      }
    },
    methods: {
       checkPermission,
    // 获取按钮权限
    getButtonPower(){
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if(this.checkPermission(['supplierManage_tab_list'],this.permissionLists)&&(this.isNull(this.$route.query.active))){
              this.activeName = 'first'
              // 表头
              this.getTableTitleLists()
              this.getOneLists()
            }else if((!this.checkPermission(['supplierManage_tab_list'],this.permissionLists))&&(this.checkPermission(['supplierManage_tab_remind'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
              this.$router.push({
                  path: '/teamReminder',
                  query:{
                      jumpname:'team',
                      active:'second'
                  }
              })
            }else if((!this.checkPermission(['supplierManage_tab_list'],this.permissionLists))&&(!this.checkPermission(['supplierManage_tab_remind'],this.permissionLists))&&(this.checkPermission(['supplierManage_tab_recertification'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
              this.$router.push({
                  path: '/recertification',
                  query:{
                    active:'third'
                  }
              })
            }
          }else{
            this.permissionLists = []
            this.activeName = ''
          }
        }else{
          this.permissionLists = []
          this.activeName = ''
        }
      })
    },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        // 解绑信息员
        unbindHandle(){
          this.infoQuery.StrTeamUserid = ''
        },
        // 更改信息员
        editInfoHandle(row){
          this.infoQuery.GdteamId = row.GdteamId
          this.infoQuery.StrTeamUserid = row.StrTeamUserid
          this.cusVisible = true
        },
        saveCusHandle(){
          // if(this.isNull(this.infoQuery.StrTeamUserid)){
          //   this.$message({
          //     type: 'warning',
          //     message: '请选择更改人员'
          //   })
          //   return
          // }
          xz.saveTeamUserid(this.infoQuery).then(res => {
            if (res.status == 'ok') {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.getList()
              this.cusVisible = false
            }else{
              this.$message({
                type: 'error',
                message: '操作失败,请稍后再试'
              })
            }
          })
         },
        // 获取人员列表
        getOneLists(){
          xz.getTeamUserList(this.oneQuery).then(res => {
            if (res.status == 'ok') {
              this.custList = res.msg
            }else{
              this.custList = []
            }
          })
        },
        // 导出
        exportHandle(){
          this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
          this.exportQuery.currpage = 1
          this.exportQuery.perpage = 1000000
          this.btnLoading = true
          // console.log('ll',param)
          xz.OutputTeamList(this.exportQuery,this.titleQuery.strTableId).then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              this.custPath = res.stroutpath
              this.downVisible = true
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnLoading = false
          })
        },
        // 确定下载导出数据
        confirmDown() {
          let path = this.tablePath + this.custPath
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
          this.downVisible = false
        },
        // 新增供应商
        addSupHandle(){
          this.$router.push({
            path: '/updateSupply',
            query: {
              // pname: 'processed'
            }
          })
        },
        // 编辑
        editHandle(row){
          // console.log('11',row)
          this.$router.push({
            path: '/updateSupply',
            query: {
              id: row.GdteamId
            }
          })
        },
        handleClick(tab, event) {
            // console.log(tab, event);
            this.activeName = tab.name
            if(tab.name == 'second'){
              this.$router.push({
                path: '/teamReminder',
                query: {
                  jumpname: 'team',
                  active:'second'
                }
              })
            }else if(tab.name == 'third'){
              this.$router.push({
                path: '/recertification',
                query:{
                  active:'third'
                }
              })
            }
        },
        // 退出
        exitHandle(row){
          this.exitVisible = true
          this.exitQuery.GdupId = row.GdteamId
          this.exitQuery.DtexitDate = ''
          this.exitQuery.strRemark = ''
        },
        // 保存修改退出时间
        saveExitHandle(){
          this.$refs['exitForm'].validate((valid) => {
            if (valid) {
              xz.saveConstrDtexitDate(this.exitQuery).then(res => {
                if (res.status == 'ok') {
                  this.$message({ type: 'success', message: '操作成功' })
                  this.getList()
                  this.exitVisible = false
                }else{
                  this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                }
              })
            } else {
              return false;
            }
          })
        },
        // 详情
        dtlHandle(row){
          let routeUrl = this.$router.resolve(
            { path: '/supplyDetail',query:{
              id: row.GdteamId
            }
          });
          window.open(routeUrl.href, '_blank');
        },
        // 认证申请
        applyHandle(row){
          let routeUrl = this.$router.resolve(
            { path: '/recertification',query:{
              code: row.StrConstrteamCode
            }
          });
          window.open(routeUrl.href, '_blank');
        },
        // 获取表头
        getTableTitleLists(){
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
            console.log('表头', res)
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getConstrTeamLists(this.listQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.tableData = res.msg
                  this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
            this.listQuery = this.$options.data.call(this).listQuery
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.auth_box{
  display: flex;
  align-items: center;
}
.auth_title{
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.auth_box img{
  width: 20px;
  height: 20px;
}
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
</style>
<style>
.p_supplys_module .el-tabs__header{
  margin-bottom: 0;
}
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>